module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-1-2-1806d2dce569c337423c10d611969928.png";